import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-finances',
  template: `
    <app-bar flTrackingSection="SubnavFinances">
      <app-bar-item
        link="/users/financial-dash"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="Finances"
        [exactLink]="true"
      >
        Finances
      </app-bar-item>
      <app-bar-item
        link="/payments/transactions.php"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="TransactionHistory"
        [exactLink]="true"
      >
        Transaction History
      </app-bar-item>
      <app-bar-item
        link="/payments/verify.php"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="VerifyPaymentMethod"
        [exactLink]="true"
      >
        Verify Payment Method
      </app-bar-item>
      <app-bar-item
        link="/deposit"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="DepositFunds"
        [exactLink]="true"
      >
        Deposit Funds
      </app-bar-item>
      <app-bar-item
        link="/payments/withdraw.php"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="WithdrawMoney"
        [exactLink]="true"
      >
        Withdraw Money
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryFinancesComponent {
  ButtonColor = ButtonColor;
}
